module.exports = __webpack_public_path__ + "img/nanjing.d3a0a3c0.png";